import { FC, useEffect, useState } from "react";
import {
  IProductFieldProps,
} from "../../../Interfaces/Product/IProduct";
import { useSelector } from "react-redux";
import store from "../../../Store/store";
import { editTablePayload } from "../../../Redux/Actions/editTableActions";
import { storeAddPayload } from "../../../Redux/Actions/popupActions";
import ProductEditForm from "./productEditForm";
import { consolelog } from "../../../helpers/consolelog";
import { IFoodVolumetricsReviewType, initialStateFoodVolumetricsReviewType } from "../../../Interfaces/IFoodVolumetricsReviewType";
import { validateFoodVolumetricsForm } from "./productValidations";

const ProductFoodVolumetricsFields: FC<IProductFieldProps> = ({ closeModal, isEdit }) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [foodVolumetricsReview, setFoodVolumetricsReview] = useState<IFoodVolumetricsReviewType>(
    payload.data?.editPayload ? payload.data.editPayload : initialStateFoodVolumetricsReviewType
  );

  useEffect(() => {
    if (payload.data) {
      setFoodVolumetricsReview(payload.data.editPayload);
    } else {
      setFoodVolumetricsReview(initialStateFoodVolumetricsReviewType);
    }
  }, [payload]);


  const handleBlur = (target: any) => {
    const { values, errors } = foodVolumetricsReview;

    const validationResult = validateFoodVolumetricsForm(values);

    setFoodVolumetricsReview((initialState: IFoodVolumetricsReviewType) => {
      return {
        ...initialState,
        errors: { ...errors, ...validationResult.errors }
      };
    });
  };

  const handleChange = (target: any, isCheckBox: boolean = false) => {
    setFoodVolumetricsReview((previousState: IFoodVolumetricsReviewType) => {
          return {
            ...previousState,
            values: { ...previousState.values, [target.name]: isCheckBox ? target.checked : target.value },
            dirty: true,
          };
    });
  };

  const { values, errors, submitted, dirty, warnings } = foodVolumetricsReview;

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const { values } = foodVolumetricsReview;

    const validationResult = validateFoodVolumetricsForm(values);

    setFoodVolumetricsReview((initialState: IFoodVolumetricsReviewType) => {
      return {
        ...initialState,
        errors: { ...errors, ...validationResult.errors },
        submitted: validationResult.isValid,
      };
    });

    if (!validationResult.isValid) {
      setTimeout(scrollToError, 100);

      return;
    }

    if (isEdit) {
      const editPayload = {
        Id: payload.data.id,
        dcp: values.dcp,
        originalRowNumber: values.originalRowNumber,
        superCatDesc: values.superCatDesc,
        deptCode: values.deptCode,
        commCode: values.commCode,
        packSize: values.packSize,
        skuNo: values.skuNo,
        suppCode: values.suppCode,
        suppName: values.suppName,
        officeDesc: values.officeDesc,
        desc: values.desc,
        breakPack: values.breakPack,
        caseLengthMm: values.caseLengthMm,
        caseWidthMm: values.caseWidthMm,
        caseHeightMm: values.caseHeightMm,
        caseWeightKg: values.caseWeightKg,
        weightUom: values.weightUom,
        casesPerLayer: values.casesPerLayer,
        layersPerPallet: values.layersPerPallet,
        casesPerPallet: (values.casesPerLayer && values.layersPerPallet) 
                        ? (values.casesPerLayer * values.layersPerPallet) 
                        : 0,
        rejectionReason: values.rejectionReason,
        fileName: values.fileName,
        uploadDate: values.uploadDate,
        status: values.status,
        overridenValidations: values.overridenValidations
      };
      store.dispatch(editTablePayload(editPayload));
    } else {
      store.dispatch(storeAddPayload({ addPayload: { ...foodVolumetricsReview.values } }));
    }

    closeModal();
  };

  const clearAll = (e: any) => {
    if (isEdit) {
      consolelog("edit mode");
      setFoodVolumetricsReview(payload.data.editPayload);
    } else {
      setFoodVolumetricsReview(initialStateFoodVolumetricsReviewType);
    }
  };

  const scrollToError = () => {
    const firstError = document.querySelector(
      ".ln-c-form-group.has-error"
    );

    if (firstError) {
      const firstErrorHtmlElement = firstError as HTMLElement;
      window.scrollTo(0, firstErrorHtmlElement.offsetTop);
      const inputField = firstErrorHtmlElement.querySelector(
        "input"
      ) as HTMLElement | null;
      inputField?.focus();
    }
  };

  return (
    <>
      <h4 className="duTypeModal-heading">
        Edit {payload.data?.selectedMenu || "Food Volumetrics"}
      </h4>
      <ProductEditForm
        values={values}
        onBlur={(event) => handleBlur(event.target)}
        onChange={(
          e,
          ...params
        ) => {
          handleChange(e.target, params[2]);
        }}
        onSubmit={(event) => handleSubmit(event)}
        onClearAll={(event) => clearAll(event)}
        onCancel={closeModal}
        errors={errors}
        dirty={dirty}
        warnings={warnings}
        submitted={submitted}
        isEdit={isEdit}
      />
    </>
  );
};

export default ProductFoodVolumetricsFields;